import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { LoadingComponent } from 'components/Loading';
import { ButtonContainer, ButtonText, ButtonImage, GlobalStyle } from './styles';
import googleLogo from '../../assets/google-logo.png';
import { checkIfComplainerExistsSocialRequest, loginReclamante } from 'api/services/Reclamante';
import { getItemInStorage, useLocalStorage } from 'hooks/useLocalStorage';
import { IReclamante } from 'dtos/Reclamante';
import { useToast } from 'hooks/toast';
import { montarCaminho } from '../../router';

export default function GoogleButton() {
  const [codMunicipio, setCodMunicipio] = useLocalStorage<number>('cod_municipio', -1);
  const [codParqueServico, setCodParqueServico] = useLocalStorage<number>('cod_parque_servico', -1);
  const [, setAccessToken] = useLocalStorage<string | undefined>('accessToken', '');
  const [, setRefreshToken] = useLocalStorage<string | undefined>('refreshToken', '');
  const [, setDadosReclamante] = useLocalStorage<IReclamante | string>('reclamante', '');
  const [loading, setLoading] = useState(false);

  const toast = useToast();
  const history = useHistory();

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setLoading(true);

      const { access_token } = tokenResponse;

      const responseGoogle = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });

      const data = responseGoogle.data;

      if (!data) {
        setLoading(false);
        return toast.addToast({
          type: 'error',
          description: 'Ocorreu um erro ao fazer login com Google!',
        });
      }

      const { email, name } = data;

      const complainerExists = await checkIfComplainerExistsSocialRequest({
        value: email,
      });

      if (!complainerExists?.data) {
        setLoading(false);

        return toast.addToast({
          type: 'error',
          description: 'Ocorreu um erro ao fazer login com Google!',
        });
      }

      if (complainerExists?.data?.user_exists === true) {
        const res = await loginReclamante({
          accessTokenGoogle: access_token,
          cod_municipio: Number(codMunicipio),
          cod_parque_servico: Number(codParqueServico),
        });

        if (res.failed) {
          setLoading(false);
          throw new Error(res.message);
        }

        if (!res.data || !res.data.complainant) {
          setLoading(false);

          throw new Error('Usuário ou senha inválidos!');
        }

        const { 'x-access-token': accessToken, 'x-refresh-token': refreshToken } = res.headers;

        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
        setDadosReclamante(res.data.complainant);

        toast.addToast({
          type: 'success',
          description: 'Usuário logado com sucesso!',
        });

        const redirectCodPontoServico = Number(getItemInStorage('redirect_cod_ponto_servico'));
        const redirectEtiquetaPonto = getItemInStorage('redirect_etiqueta_ponto');

        setLoading(false);
        history.push(
          redirectCodPontoServico && redirectCodPontoServico !== -1 && redirectEtiquetaPonto
            ? montarCaminho('/generate/ponto')
            : montarCaminho('/home'),
        );
      } else {
        const dataNewAccount = {
          nom_nome_completo: name,
          nom_email: email,
          nom_email_google: email,
        };

        history.push(montarCaminho('/new-account'), dataNewAccount);
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log('Erro login google:', error);
    },
  });

  const handleLoginGoogle = () => {
    if (loading) return;

    login();
  };

  return (
    <>
      <GlobalStyle />
      <ButtonContainer onClick={handleLoginGoogle}>
        {loading ? (
          <>
            <LoadingComponent size={16} style={{ width: '16px' }} button color={'#7764e4'} />
          </>
        ) : (
          <>
            <ButtonText>Entrar com</ButtonText>
            <ButtonImage src={googleLogo} alt="google" />
          </>
        )}
      </ButtonContainer>
    </>
  );
}
